var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogoJcb = function SvgCardLogoJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 86,
    fill: "none",
    viewBox: "0 0 64 43"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 41.67,
    x: 0.5,
    y: 0.5,
    fill: "#F9F9FA",
    rx: 6.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 41.67,
    x: 0.5,
    y: 0.5,
    stroke: "#DFE0E5",
    rx: 6.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.996 30.986a6.53 6.53 0 0 1-6.52 6.52H11.005V11.684a6.53 6.53 0 0 1 6.52-6.52h35.472z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo-jcb_svg__a)",
    d: "M41.446 24.363h2.695c.077 0 .257-.026.334-.026.513-.102.95-.564.95-1.206 0-.616-.437-1.078-.95-1.206-.077-.026-.231-.026-.334-.026h-2.695z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo-jcb_svg__b)",
    d: "M43.833 7.347a4.67 4.67 0 0 0-4.672 4.672v4.85h6.597c.154 0 .333 0 .462.026 1.488.078 2.592.848 2.592 2.182 0 1.053-.744 1.95-2.13 2.13v.052c1.514.103 2.67.95 2.67 2.259 0 1.411-1.284 2.335-2.978 2.335h-7.239v9.497h6.854a4.67 4.67 0 0 0 4.671-4.671V7.347z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo-jcb_svg__c)",
    d: "M45.09 19.386c0-.616-.436-1.027-.949-1.104-.051 0-.18-.026-.256-.026h-2.439v2.26h2.439c.077 0 .23 0 .256-.027.514-.077.95-.487.95-1.103"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo-jcb_svg__d)",
    d: "M18.012 7.347a4.67 4.67 0 0 0-4.672 4.672v11.524c1.31.642 2.67 1.053 4.03 1.053 1.617 0 2.49-.976 2.49-2.31v-5.442h4.004v5.416c0 2.105-1.309 3.824-5.75 3.824-2.695 0-4.8-.59-4.8-.59v9.83h6.854a4.67 4.67 0 0 0 4.671-4.67V7.346z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo-jcb_svg__e)",
    d: "M30.922 7.347a4.67 4.67 0 0 0-4.671 4.672v6.109c1.18-1.001 3.234-1.643 6.545-1.49 1.77.078 3.67.565 3.67.565v1.977c-.95-.488-2.079-.924-3.542-1.027-2.515-.18-4.03 1.053-4.03 3.209 0 2.181 1.515 3.413 4.03 3.208 1.463-.103 2.593-.565 3.542-1.027v1.977s-1.873.487-3.67.564c-3.311.154-5.365-.487-6.545-1.488v10.78h6.853a4.67 4.67 0 0 0 4.671-4.671V7.347z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-logo-jcb_svg__a",
    x1: 39.157,
    x2: 50.692,
    y1: 23.134,
    y2: 23.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-logo-jcb_svg__b",
    x1: 39.157,
    x2: 50.692,
    y1: 21.338,
    y2: 21.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-logo-jcb_svg__c",
    x1: 39.157,
    x2: 50.692,
    y1: 19.383,
    y2: 19.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-logo-jcb_svg__d",
    x1: 13.335,
    x2: 25.048,
    y1: 21.338,
    y2: 21.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-logo-jcb_svg__e",
    x1: 26.184,
    x2: 37.56,
    y1: 21.338,
    y2: 21.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
};
export default SvgCardLogoJcb;